import "./services/httpAccess";
import React, { lazy } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store, persistor } from "./state/redux/store";
import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n";
import "./index2.css";
import { PersistGate } from "redux-persist/integration/react";

const LazyApp = lazy(() => import("./app/App"));

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LazyApp />
        </PersistGate>
      </Provider>
    </React.StrictMode>,
  );
}
